import { useCallback } from 'react';
import { useQueryClient } from '@zg-rentals/react-query5';

/**
 * Invalidate the unread conversation count (`satellite:conversationCounts`). The realtime list
 * views refetch the conversation list on an incoming message but never the separate counts query,
 * so it stays stale until a user action or the staleTime window — call this alongside the list
 * refetch so the inbox count (and, in SLW, the top-nav badge that shares this query) stays live.
 */
export function useInvalidateMessageCounts() {
  const queryClient = useQueryClient();

  return useCallback(() => {
    queryClient.invalidateQueries({
      predicate: (query) => {
        const tags = (query.meta as { tags?: Array<string> })?.tags;
        return tags?.includes('satellite:conversationCounts') ?? false;
      },
    });
  }, [queryClient]);
}
